/**
 * Adds a module to the current rack by sending a POST request to the API.
 * 
 * @param {object} module - The module to be added. It should contain the properties required by the API.
 * @param {object} currentRack - The current rack to which the module will be added. It should contain the properties required by the API.
 * @returns {Promise<Array>|null} - Returns a Promise that resolves to the list of ordered modules if the addition is successful, or null in case of an error.
 */
import toast from "react-hot-toast";

export const addModule = async (module, currentRack) => {
    try {
        const response = await fetch('https://d10xp9krdkfyts.cloudfront.net/api/addModule', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ currentRack: currentRack, module: module }),
        });

        const data = await response.json();

        if (data.status === 'success') {
            return data.ordered_modules;
        } else {
             toast.error(data.message);
            return null;
        }
    } catch (error) {
         toast.error('Unable to fetch data from server');
        console.error('Error:', error);
        return null;
    }
};
